/**
 * @generated SignedSource<<6d5ec91ef3195f2ab3b8627a97978fc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type showExam$data = {
  readonly id: string;
  readonly myRegistration: {
    readonly final: boolean;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ExamSubmitted" | "ExamTaker">;
  readonly " $fragmentType": "showExam";
};
export type showExam$key = {
  readonly " $data"?: showExam$data;
  readonly " $fragmentSpreads": FragmentRefs<"showExam">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "showExam",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExamSubmitted"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExamTaker"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Registration",
      "kind": "LinkedField",
      "name": "myRegistration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "final",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Exam",
  "abstractKey": null
};

(node as any).hash = "787553468d1c0c55df3978b7535d2c09";

export default node;
